import { render, staticRenderFns } from "./RegisterStepComment.vue?vue&type=template&id=6db2deea&"
import script from "./RegisterStepComment.vue?vue&type=script&lang=js&"
export * from "./RegisterStepComment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports